import * as ActionTypes from '../actions/actionTypes';
import {calculateMgrs} from '../utils/point_utils';

const initialState = { latlng: null, lat: null, lng: null, mgrs: 'Not set', fuel_type: '', incident_name: '' };

const reducer = (state = initialState, action) => {
  switch (action.type) {

    case ActionTypes.SET_ACTIVE_POINT:
      return {
        ...state,
        latlng: action.latlng,
        lat: action.latlng.lat,
        lng: action.latlng.lng,
        mgrs: calculateMgrs(action.latlng.lat, action.latlng.lng),
        fuel_type: '',
        incident_name: ''
      };

    case ActionTypes.SET_POINT_FUEL_TYPE:
      return {
        ...state,
        fuel_type: action.fuel_type
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/point.js